import React from "react";
import { Link } from "react-router-dom";
import ShowAwardsList from "./ShowAwardsList";
import { useActiveGenre } from "../../../../utils/Genre/activeGenreState";

export default function ShowAwardsSidebarContainer({
  genreSlug,
  showSlug,
  showAwards,
}) {
  const [activeGenre] = useActiveGenre();

  return (
    <>
      <div className="show-left-column-awards-container scrollable">
        <div className="show-left-column-awards-content">
          <div className="award-column-title d-flex justify-content-center align-items-center gap-3">
            <div>Nominations and Wins</div>
            <Link
              to={`/${genreSlug}/${showSlug}/awards`}
              className="award-column-viewall"
            >
              View All
            </Link>
          </div>
          {showAwards && <ShowAwardsList showAwards={showAwards} />}
        </div>
      </div>
    </>
  );
}
